<template>
  <div>
    <div>
      <div v-if="!short" style="display: flex; justify-content: space-between; align-items: center">
        <v-btn
          fab
          depressed
          color="black"
          dark
          small
          :to="`/regalos/campaign/${campaign_id}/idea/${idea_id}/option/${option_id}/view`"
          ><v-icon>mdi-close</v-icon></v-btn
        >
        <v-btn fab depressed color="success" small @click="save"><v-icon>mdi-check</v-icon></v-btn>
      </div>

      <h1>Editar opción</h1>
    </div>

    <v-text-field prepend-inner-icon="mdi-link" outlined v-model="option.link" label="link"></v-text-field>
    <v-btn v-if="option.link" @click="autoFill" block color="primary" depressed :loading="loading">Auto Fill</v-btn>
    <hr v-else />
    <br />
    <v-text-field outlined v-model="option.title" label="title"></v-text-field>
    <v-text-field outlined v-model="option.price" type="number" label="price"></v-text-field>
    <v-text-field outlined v-model="option.description" label="description"></v-text-field>
    <v-text-field v-if="false" outlined v-model="option.currency" label="currency"></v-text-field>

    <!-- show image_url only if no image_key (no image uploaded) or already having an image_url -->
    <v-text-field
      v-if="!option.image_key || option.image_url"
      outlined
      v-model="option.image_url"
      label="image_url"
    ></v-text-field>

    <!-- image preview -->
    <div v-if="option.image_url || temp_image_url" style="text-align: center">
      <img
        :src="temp_image_url || option.image_url"
        style="width: 200px; max-width: 500px; height: auto; object-fit: contain"
        :alt="option.title"
      />
    </div>

    <!-- image picker -->
    <div v-if="!option.image_key">
      <ImagePicker @done="imageUploaded($event)" folder="regalos" :filename="option.id" />
    </div>
    <div v-else>
      <v-btn depressed @click="option.image_key = undefined">Change Image</v-btn>
    </div>

    <!-- debug -->
    <div v-if="false">
      {{ option }}
    </div>
  </div>
</template>

<script>
import api from '@/assets/api'
import { v4 as uuidv4 } from 'uuid'

import ImagePicker from '@/components/ImagePicker.vue'
export default {
  components: {
    ImagePicker,
  },
  props: {
    campaign_id: {
      type: String,
      default: '',
    },
    idea_id: { type: String, default: '' },
    option_id: { type: String, default: '' },
    short: { type: Boolean, default: false },
  },
  watch: {
    option(newValue, oldValue) {
      if (newValue.image_url !== oldValue.image_url) {
        //image url changed, remove image_key to replace it
        //  but only if the url doens't include the image_key (it would be the signed url)
        if (!newValue.image_url.includes(newValue.image_key)) {
          this.option.image_key = undefined
        }
      }
    },
  },
  data() {
    return {
      option: {},
      temp_image_url: '',
      loading: false,
    }
  },
  methods: {
    imageUploaded(data) {
      console.log('image uploaded with key: ' + data.key)
      this.option.image_key = data.key
      this.option.image_url = '' //erase previous image
      this.temp_image_url = data.viewUrl
      this.option = { ...this.option }
    },
    async save() {
      if (!this.option.campaign_id) this.option.campaign_id = this.campaign_id
      if (!this.option.idea_id) this.option.idea_id = this.idea_id

      let x = await api.apiFetch(`/regalos/option`, {
        method: 'POST',
        body: JSON.stringify(this.option),
      })
      if (!x.ok) {
        const t = await x.text()
        console.warn(x.status + ': ' + t)
        return alert('something failed')
      }
      this.option = await x.json()
      this.$router.push(`/regalos/campaign/${this.campaign_id}/idea/${this.idea_id}/option/${this.option_id}/view`)
    },
    async fetchData() {
      let x = await api.apiFetch(`/regalos/campaign?id=${this.campaign_id}`)
      if (!x.ok) return alert('something failed')
      let j = await x.json()
      this.campaign = j
      if (!j.ideas) j.ideas = []
      const idea = j.ideas.find((i) => i.id == this.idea_id)
      if (!idea) return alert('idea not found')
      this.idea = idea

      if (!idea.options) idea.options = []
      const option = idea.options.find((i) => i.id == this.option_id)
      this.option = option
    },
    async autoFill() {
      this.loading = true
      const link = this.option.link
      if (!link) return alert('Falta un link...')
      const linkk = encodeURIComponent(link)

      const x = await api.apiFetch(`/regalos/parse-link?link=${linkk}`)
      this.loading = false
      if (!x.ok) return alert('Error al parsear el link. Prueba más tarde o mete los datos a mano')
      const data = await x.json()

      let current_price = data.current_price || data.offers?.price
      if (this.option.price && current_price && this.option.price != current_price) {
        let conf = confirm(
          `El precio actual ${current_price} es diferente al que ya tenías (${this.option.price}). ¿Quieres sobreescribirlo?`
        )
        if (!conf) current_price = this.option.price
      }

      //actual parse:
      this.option.title = data.title
      this.option.description = data.description
      this.option.image_url = data.image_url
      this.option.price = current_price
      this.option.currency = data.currency || 'EUR'

      this.option = { ...this.option }
    },
  },
  mounted() {
    this.fetchData()
  },
}
</script>

<style lang="scss" scoped></style>
